/* eslint-disable sort-keys */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'

import { Image } from '../../components'
import richTextRenderer from '../../components/RichTextParser/RichTextParser'
import { Kicker } from '../../components/Typography'
import HeadingComponent from '../../components/Typography/HeadingComponent/HeadingComponent'
import useMediaQuery from '../../hooks/useMediaQuery'
import { ALLOWED_WORDS, replaceWordInString } from '../../utils/helpers'
import { CloseIcon } from '../../utils/icons'
import Modal from '../Modal/Modal'
import {
  closeIcon,
  contactImage,
  container,
  contentRowContainerStyling,
  contentStyling,
  cursorPointer,
  darkBgStyling,
  mobileImage,
  mobileVideo,
  modalVideo,
  playButton,
  sectionContainer,
  videoContainer,
  videoPlacement,
} from './NewTreatmentIntroSection.module.css'

const PlayIcon = ({ className }) => (
  <svg
    className={className}
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="#FF0000" height="16" rx="3" ry="3" width="20" x="2" y="4" />
    <path d="M8 5v14l11-7z" fill="white" />
  </svg>
)

const NewTreatmentIntroSection = ({ component, lang, pageType, slice }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [videoLoaded, setVideoLoaded] = useState(false)

  const {
    treatmentintrobackground,
    treatmentintrocontent,
    treatmentintroheading,
    treatmentintrokicker,
    ytvideoid,
  } = slice
  const isDesktop = useMediaQuery('(min-width: 768px)')
  const lightHeadingComponents =
    component === 'aboutintro' ||
    component === 'contactmixedcontent' ||
    pageType === 'about' ||
    pageType === 'contact'
  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setTimeout(() => setVideoLoaded(false), 300)
  }

  const handleVideoLoad = () => {
    setVideoLoaded(true)
  }

  const videoUrl = `https://www.youtube.com/embed/${ytvideoid}`
  const thumbnailUrl = `https://img.youtube.com/vi/${ytvideoid}/maxresdefault.jpg`

  return (
    <section className={sectionContainer}>
      {treatmentintrokicker && <Kicker>{treatmentintrokicker}</Kicker>}
      {treatmentintroheading && (
        <HeadingComponent>
          {replaceWordInString(
            treatmentintroheading,
            'botox',
            ALLOWED_WORDS[lang],
          )}
        </HeadingComponent>
      )}
      <div className={contentRowContainerStyling}>
        <div
          className={`${contentStyling} ${
            lightHeadingComponents && isDesktop ? darkBgStyling : ''
          }`}
        >
          {treatmentintrocontent &&
            richTextRenderer(
              replaceWordInString(
                treatmentintrocontent,
                'botox',
                ALLOWED_WORDS[lang],
              ),
            )}
        </div>
        {(ytvideoid || treatmentintrobackground) && (
          <div
            className={`${videoContainer} ${ytvideoid ? cursorPointer : ''}`}
          >
            {ytvideoid ? (
              isDesktop ? (
                <div onClick={handleOpenModal} role="presentation">
                  <Image
                    alt={treatmentintrobackground?.alt || 'Kliniken Image'}
                    className={
                      component === 'contactmixedcontent'
                        ? contactImage
                        : mobileImage
                    }
                    src={
                      treatmentintrobackground?.node.localFile.childImageSharp
                    }
                  />
                  <PlayIcon className={playButton} />
                </div>
              ) : (
                <div className={mobileVideo}>
                  {!videoLoaded ? (
                    <div
                      onClick={handleVideoLoad}
                      role="presentation"
                      style={{
                        backgroundImage: `url(${thumbnailUrl})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      <PlayIcon className={playButton} />
                    </div>
                  ) : (
                    <iframe
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className={mobileVideo}
                      frameBorder="0"
                      loading="lazy"
                      src={videoUrl}
                      title="YouTube Video"
                    />
                  )}
                </div>
              )
            ) : (
              treatmentintrobackground && (
                <Image
                  alt={treatmentintrobackground?.alt || 'Kliniken Image'}
                  className={
                    component === 'contactmixedcontent'
                      ? contactImage
                      : mobileImage
                  }
                  src={treatmentintrobackground.node.localFile.childImageSharp}
                />
              )
            )}
            <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
              <div className={container}>
                <div className={videoPlacement}>
                  {isModalOpen && (
                    <iframe
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className={modalVideo}
                      frameBorder="0"
                      loading="lazy"
                      src={videoUrl}
                      title="YouTube Video"
                    />
                  )}
                  <div onClick={handleCloseModal} role="presentation">
                    <CloseIcon className={closeIcon} />
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        )}
      </div>
    </section>
  )
}

export default NewTreatmentIntroSection
